// Индекс результата
export const INDEX_OF_THE_RESULT = "253";

// Индекс работоспособности
export const INDEX_OF_HEALTH = "387";
